module.exports = __webpack_public_path__ + "img/1280x720-Futurism.36e3f435.jpg";